import { render, staticRenderFns } from "./temuCreateTemplate.vue?vue&type=template&id=64af459b&scoped=true"
import script from "./temuCreateTemplate.vue?vue&type=script&lang=js"
export * from "./temuCreateTemplate.vue?vue&type=script&lang=js"
import style0 from "./temuCreateTemplate.vue?vue&type=style&index=0&id=64af459b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64af459b",
  null
  
)

export default component.exports